/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneTextArea from 'base/components/standalone/TextArea';

export const DynamicStandaloneTextArea = StandaloneTextArea;
export type DynamicStandaloneTextAreaProps = PropsFromComponent<typeof StandaloneTextArea>;

export const DynamicStandaloneTextAreaWith = (extras: DynamicStandaloneExtras): typeof StandaloneTextArea => {
    return function DynamicStandaloneTextArea(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'TextArea');
        return <StandaloneTextArea {...mergeProps({ options: { theme } }, props)} />;
    }
}